import { QuickAction } from "src/apis/userApi";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripHorizontal } from "lucide-react";
import { Button } from "@pushpress/pushpress-ui";
import { iconMap, DEFAULT_QUICK_ACTION_ICON } from "./QuickActions";
import { cn } from "../../../utils/css";

export interface SortableQuickActionProps {
  quickAction: QuickAction;
  onActionClick: (quickAction: QuickAction) => void;
}

const secondaryStyles =
  "tw-w-full lg:tw-flex-1 tw-outline tw-pl-6 tw-outline-gray-100 hover:tw-outline-gray-200 [&>svg]:tw-text-gray-500 [&>span]:tw-text-gray-600";

export const SortableQuickAction = ({
  quickAction,
  onActionClick,
}: SortableQuickActionProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: quickAction.action });

  const variant =
    quickAction.value === "CHECKIN_SIDE_PANEL" ? "default" : "secondary";
  const IconComponent =
    iconMap[quickAction.value as keyof typeof iconMap] ??
    DEFAULT_QUICK_ACTION_ICON;

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.6 : 1,
      }}
      className="tw-flex tw-w-full lg:tw-flex-1 tw-relative tw-group"
    >
      <div
        className="tw-absolute tw-left-1 tw-inset-y-0 tw-z-10 tw-flex tw-items-center tw-cursor-grab tw-opacity-0 group-hover:tw-opacity-70"
        {...attributes}
        {...listeners}
      >
        <GripHorizontal
          className={cn(
            "tw-w-4 tw-h-4",
            variant === "default" && "tw-text-white",
          )}
        />
      </div>

      <Button
        variant={variant}
        rounded
        className={
          variant === "secondary"
            ? secondaryStyles
            : "tw-w-full lg:tw-flex-1 tw-pl-6"
        }
        onClick={() => onActionClick(quickAction)}
      >
        <IconComponent className="tw-w-4 tw-h-4 tw-mr-2 tw-flex-shrink-0" />
        <span className="tw-truncate">{quickAction.label}</span>
      </Button>
    </div>
  );
};
